"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataType = void 0;
var DataType;
(function (DataType) {
    DataType["exchangeOrder"] = "pionex_order";
    DataType["botOrder"] = "bu_order";
    DataType["announcement"] = "web_notice";
    DataType["pionex_wallet"] = "pionex_wallet";
    /**条件单 */
    DataType["pionex_trigger"] = "pionex_trigger";
    // 通知
    DataType["pionex_online_notify"] = "pionex_online_notify";
    DataType["swapx_balance"] = "swapx_balance";
    DataType["swapx_transaction"] = "swapx_transaction";
    DataType["ping"] = "ping";
    DataType["pong"] = "pong";
    // 合约杠杆变更
    DataType["leverage"] = "leverage";
    DataType["all"] = "all";
})(DataType = exports.DataType || (exports.DataType = {}));
